import { render } from "./MIInvestmentsCard.vue?vue&type=template&id=1463bbe6&scoped=true"
import script from "./MIInvestmentsCard.vue?vue&type=script&lang=js"
export * from "./MIInvestmentsCard.vue?vue&type=script&lang=js"

import "./MIInvestmentsCard.vue?vue&type=style&index=0&id=1463bbe6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1463bbe6"

export default script